import classnames from 'classnames';
import { useMemo } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const marginNumbers = [0, 2, 4, 8, 12, 16, 24, 36, 48];
(() => {
  if (typeof window !== "undefined" && !document.querySelector("#mds-use-margin-style")) {
    const style = document.createElement("style");
    style.setAttribute("type", "text/css");
    style.setAttribute("id", "mds-use-margin-style");
    style.textContent = marginNumbers.map(
      (number) => `
.mds-margin-${number} {margin: ${number}px !important;}
.mds-margin-vertical-${number} {margin-top: ${number}px !important; margin-bottom: ${number}px !important;}
.mds-margin-horizontal-${number} {margin-left: ${number}px !important; margin-right: ${number}px !important;}
.mds-margin-top-${number} {margin-top: ${number}px !important;}
.mds-margin-right-${number} {margin-right: ${number}px !important;}
.mds-margin-bottom-${number} {margin-bottom: ${number}px !important;}
.mds-margin-left-${number} {margin-left: ${number}px !important;}`
    ).join("");
    document.head.append(style);
  }
})();
const useMargin = /* @__PURE__ */ __name((margin) => useMemo(() => {
  if (typeof margin === "undefined") {
    return "";
  }
  if (typeof margin === "number") {
    return `mds-margin-${margin}`;
  }
  if (Array.isArray(margin)) {
    switch (margin.length) {
      case 1:
        return `mds-margin-${margin[0]}`;
      case 2:
        return `mds-margin-vertical-${margin[0]} mds-margin-horizontal-${margin[1]}`;
      case 3:
        return `mds-margin-top-${margin[0]} mds-margin-horizontal-${margin[1]} mds-margin-bottom-${margin[2]}`;
      case 4:
        return `mds-margin-top-${margin[0]} mds-margin-right-${margin[1]} mds-margin-bottom-${margin[2]} mds-margin-left-${margin[3]}`;
    }
  }
  const { bottom, left, right, top } = margin;
  return classnames({
    [`mds-margin-top-${top}`]: top !== void 0,
    [`mds-margin-right-${right}`]: right !== void 0,
    [`mds-margin-bottom-${bottom}`]: bottom !== void 0,
    [`mds-margin-left-${left}`]: left !== void 0
  });
}, [margin]), "useMargin");

export { useMargin };
//# sourceMappingURL=index.js.map
